<template>
  <div class="bo-accordion bo-padding-std" :class="{ active: tab === value }">
    <a href="#" :title="$t('Show more')" class="acc-toggle" @click.stop="toggleTab">
      <b-icon icon="caret-right-fill" />
    </a>
    <a href="#" :title="$t('Close')" class="acc-close" @click.stop="toggleTab">
      <b-icon icon="caret-down-fill" />
    </a>

    <div class="acc-header" @click.stop="toggleTab">
      <div class="acc-icon">
        <b-icon v-bind="iconProps" :icon="icon" />
      </div>
      <div class="acc-title-wrapper">
        <div class="acc-title">
          <locale-text :text="title" />
        </div>
        <div class="acc-subtitle acc-big">
          <strong>
            <slot name="title-info"></slot>
          </strong>
        </div>
      </div>
    </div>
    <div class="acc-body">
      <transition name="smooth">
        <div class="acc-content" v-if="tab === value">
          <slot></slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import LocaleText from '../common/LocaleText.vue';

export default {
  name: 'PartEditAccorion',

  components: { LocaleText },

  props: {
    title: {
      type: [String, Object],
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    tab: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: null,
    },
    iconProps: {
      type: Object,
      default: null,
    },
  },

  methods: {
    toggleTab() {
      this.$emit('input', this.tab === this.value ? '' : this.tab);
    },
  },
};
</script>

<style scoped>
/** @todo Styles are messed up. Needs cleanup. */
.bo-padding-std {
  padding-left: 15px;
  padding-right: 15px;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}
.flex-between .dotted-overflow {
  min-width: 0;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

/* Transition */
/* Accordion */
.accordion-toggler {
  position: relative;
  cursor: pointer;
  border-top: 1px solid #999;
  padding: 0.8em 0.8em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease-in-out;
  background: #f2f2f2;
}
.accordion-toggler.last:not(.active) {
  border-bottom: 1px solid #999;
}
.accordion-toggler .acc-title {
  color: #000;
  font-size: 1em;
}
.accordion-toggler .acc-title i {
  transition: all 0.4s ease-in-out;
  color: #999;
  font-size: 1em;
  margin-right: 0.2em;
}
.accordion-toggler .acc-toggle-icon:after {
  position: relative;
  top: 2px;
  font-family: 'Material Icons';
  content: 'keyboard_arrow_right';
  font-weight: bold;
  color: #666;
  display: inline-block;
  transition: all 0.4s ease;
}
.accordion-toggler:hover {
  background: #bababa;
}
.accordion-toggler.active {
  background: #d67d07;
  border-top: #d67d07;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
  z-index: 2;
}
.accordion-toggler.active .acc-title {
  color: #fff;
}
.accordion-toggler.active .acc-title i {
  color: #000;
}
.accordion-toggler.active .acc-toggle-icon:after {
  transform: rotate(90deg);
}
/* Accordion - wrapper to make bordered boxes in */
.accordion-wrapper {
  margin-top: 0em;
  padding-bottom: 10px;
}
/* Accordion V3 */
.bo-accordion {
  position: relative;
  border-top: 1px solid #f1f1f1;
  padding-top: 0.8em;
  padding-bottom: 0.8em;
  transition: all 0.2s ease-in-out;
  background: #fff;
}
.bo-accordion:last-of-type {
  padding-bottom: 15px;
  border-bottom: 1px solid #f1f1f1;
}
.bo-accordion .acc-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 48px;
}
.bo-accordion .acc-header .acc-icon {
  font-size: 1.4em;
  padding: 0px 15px 0px 8px;
  cursor: pointer;
  background: #000;
  width: 1.8em;
  min-width: 1.8em;
  height: 1.8em;
  border-radius: 50%;
  text-align: center;
  line-height: 1.7em;
  vertical-align: middle;
  padding: 0px 0px;
  color: #fff;
  margin-right: 12px;
  opacity: 0.6;
}
.bo-accordion .acc-header .acc-title-wrapper .acc-title {
  font-size: 1rem;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bo-accordion .acc-header .acc-title-wrapper .acc-subtitle {
  font-size: 1.2em;
  color: #333;
}
.bo-accordion .acc-header .acc-title-wrapper .acc-subtitle strong {
  font-weight: 600;
}
.bo-accordion .acc-header .acc-title-wrapper .acc-subtitle.acc-small,
.bo-accordion .acc-header .acc-title-wrapper .acc-subtitle .acc-small {
  font-size: 0.8em;
}
.bo-accordion .acc-header .acc-title-wrapper .acc-subtitle.acc-big {
  font-size: 1rem;
}
.bo-accordion .acc-toggle {
  position: absolute;
  right: 8px;
  top: -4px;
  font-size: 0.8em;
  color: #82bcff;
  text-decoration: none;
  padding: 4px;
}
.bo-accordion .acc-toggle:hover {
  color: #0064e0;
}
.bo-accordion .acc-close {
  position: absolute;
  display: none;
  right: 8px;
  top: -4px;
  font-size: 0.8em;
  color: #333;
  text-decoration: none;
  color: #0064e0;
  padding: 4px;
}
.bo-accordion .acc-close:hover {
  color: #82bcff;
}
.bo-accordion .acc-body .acc-content {
  margin-top: 10px;
}
.bo-accordion:hover {
  background: #f0f4f9;
}
.bo-accordion.active {
  padding-bottom: 2em;
  background: #f0f4f9;
}
.bo-accordion.active .acc-header {
  justify-content: flex-start;
  align-items: center;
}
.bo-accordion.active .acc-header .acc-icon {
  font-size: 1em;
  line-height: 1.7em;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bo-accordion.active .acc-header .acc-title-wrapper .acc-subtitle {
  display: none;
}
.bo-accordion.active .acc-toggle {
  display: none;
}
.bo-accordion.active .acc-close {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/projectplan/PartEditAccordion.vue